<ng-template #content>
  <div class="confirm-modal-container">
    <div class="confirm-modal-content">
      <div class="confirm-icon-wrapper">
        <span class="material-icons confirm-icon">{{ icon || 'help_outline' }}</span>
      </div>
      <h2 class="confirm-title">{{ title }}</h2>
      <div class="confirm-body">
        @if (bodyMarkdown) {
          <tidy-markdown [markdownContent]="bodyMarkdown" />
        } @else {
          <p>{{ body }}</p>
        }
      </div>
      @if (showAutomaticBookingQuestion) {
        <div class="auto-schedule-section">
          <div class="auto-schedule-header">
            <tidy-image
              [src]="'assets/img/automatic-booking.svg'"
              class="auto-schedule-icon" />
            <span class="auto-schedule-title">Auto-Schedule</span>
          </div>
          <p class="auto-schedule-text">
            You had a guest check out on {{ reservationDateTime }}. Do you want to keep auto-schedule on for this reservation?
          </p>
          <tidy-checkbox
            [items]="[{value: true, viewValue: 'Keep Auto-Schedule On'}]"
            [initValue]="true"
            (checkedChange)="updateAutomaticBooking($event)" />
        </div>
      }
      <div class="confirm-buttons" [class.same-row]="sameRowButtons">
        <tidy-button
          [text]="backText"
          [action]="boundBackAction"
          class="secondary full-width" />
        <tidy-button
          [text]="confirmText"
          [action]="boundConfirm"
          class="primary full-width" />
      </div>
      @if (blockAction) {
        <div class="block-action-section">
          <p class="block-action-text">Never want them again?</p>
          <tidy-button
            [text]="'Block Pro From All Properties'"
            [action]="boundTriggerBlockAction"
            class="secondary full-width" />
        </div>
      }
      @if (errorMessage) {
        <div class="error-section">
          <tidy-error-message [text]="errorMessage" />
        </div>
      }
    </div>
  </div>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
